import { useMutation, useQueryClient } from '@tanstack/react-query';

import { consumeInviteToken } from '../api/consume-invite-token.js';
import { meKeys } from './keys.js';

export function useConsumeInviteTokenMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['me', 'consumeInviteToken'],
    mutationFn: async ({ token }: { token: string }) => {
      return await consumeInviteToken(token);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: meKeys.status() });
    },
  });
}
